/**
 * UserProfile Component.
 * 
 * This component is used for displaying and managing the user's profile in the application.
 * It includes navigation to different sections and a sign-out option, represented with a dropdown menu.
 * Used on @Navbar component
 * 
 * Features:
 * - Profile Information: Shows user avatar and email initial if available.
 * - Navigation Menu: Provides links to sections like 'My Predictions' and 'Settings'.
 * - Admin Section: Additional admin-specific links if the user has admin privileges.
 * - Sign Out Functionality: Allows the user to sign out of the application.
 */

// React
import { useNavigate } from 'react-router-dom';

// Libraries
import { Menu, MenuHandler, MenuList, MenuItem, Typography } from "@material-tailwind/react";
import { InboxIcon, Square3Stack3DIcon } from '@heroicons/react/24/solid';

// Utilities
import { classNames } from '../utils';

// Hooks
import { useAuth } from '../hooks/useAuth';

interface UserProfileProps {
  /** The authenticated user object. */
  authUser: any; // Replace 'any' with a specific type if available
}

export function UserProfile({ authUser }: UserProfileProps) {
  const { handleSignOut } = useAuth()
  const navigate = useNavigate();

  const handleNavigation = (route: string) => {
    switch (route) {
      case "home":
        navigate("/");
        break;

      case "predictions":
        navigate("/mypredictions");
        break;

      case "settings":
        navigate("/settings");
        break;

      case "feedbacks":
        navigate("/admin/feedbacks");
        break;

      default:
        // history.push("/")
        break;
    }
  }

  const signOut = async () => {
    await handleSignOut()
    // route.replace("/")
  }

  return (
    <>
      <div className=" inset-y-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 ">
        {/* <Menu as="div" className="relative ml-3 ">
          <div>
            <Menu.Button className="flex rounded-full bg-indigo-600 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-400">
              <span className="sr-only">Open user menu</span>
              {authUser?.avatar ? (
                <img
                  width={32}
                  height={32}
                  className="h-8 w-8 rounded-full"
                  src={authUser?.avatar ?? ""}
                  alt="user"
                />
              ) : (
                <div className="h-8 w-8 flex items-center justify-center rounded-full text-white text-center" >
                  <h1 className="text-xl">
                    {authUser?.email && authUser?.email.charAt(0).toUpperCase()}
                  </h1>
                </div>
              )}
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-[1000] mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <Menu.Item>
                {({ active }) => (
                  <p
                  onClick={() => handleNavigation("predictions")}
                    className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer')}
                  >
                    My Predictions
                  </p>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <p
                  onClick={() => handleNavigation("settings")}
                    className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 relative cursor-pointer')}
                  >
                    Settings
                  </p>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <p
                    onClick={signOut}
                    className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 ')}
                  >
                    Sign out
                  </p>
                )}
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu> */}
        <div className="relative ml-3 ">
          <Menu placement="bottom-end">
            <MenuHandler >
              <div className={classNames(
                "flex h-8 w-8 cursor-pointer bg-indigo-600 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-400",
                authUser?.avatar ? "rounded-full" : "rounded-lg"
              )}>

                {authUser?.avatar ? (
                  <img
                    width={32}
                    height={32}
                    className="h-8 w-8 rounded-full"
                    src={authUser?.avatar ?? ""}
                    alt="user"
                  />
                ) : (
                  <div className="h-8 w-8 flex items-center justify-center rounded-full text-white text-center" >
                    <h1 className="text-xl">
                      {authUser?.email && authUser?.email.charAt(0).toUpperCase()}
                    </h1>
                  </div>
                )}
              </div>


              {/* <Avatar
              variant="circular"
              alt="tania andrew"
              className="cursor-pointer"
              src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80"
            /> */}
            </MenuHandler>
            <MenuList className="dark:bg-neutral-900 dark:border-neutral-600 dark:text-white rounded-xl" >
              {/* <MenuItem
                onClick={() => handleNavigation("settings")}
                className="flex items-center gap-2  dark:focus:bg-neutral-800  dark:focus:text-white">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM10 5C10 5.53043 9.78929 6.03914 9.41421 6.41421C9.03914 6.78929 8.53043 7 8 7C7.46957 7 6.96086 6.78929 6.58579 6.41421C6.21071 6.03914 6 5.53043 6 5C6 4.46957 6.21071 3.96086 6.58579 3.58579C6.96086 3.21071 7.46957 3 8 3C8.53043 3 9.03914 3.21071 9.41421 3.58579C9.78929 3.96086 10 4.46957 10 5ZM8 9C7.0426 8.99981 6.10528 9.27449 5.29942 9.7914C4.49356 10.3083 3.85304 11.0457 3.454 11.916C4.01668 12.5706 4.71427 13.0958 5.49894 13.4555C6.28362 13.8152 7.13681 14.0009 8 14C8.86319 14.0009 9.71638 13.8152 10.5011 13.4555C11.2857 13.0958 11.9833 12.5706 12.546 11.916C12.147 11.0457 11.5064 10.3083 10.7006 9.7914C9.89472 9.27449 8.9574 8.99981 8 9Z"
                    fill="#f4f4f4"
                  />
                </svg>

                <Typography variant="small" className="font-bold">
                  Profile
                </Typography>
              </MenuItem> */}

              <MenuItem
                onClick={() => handleNavigation("predictions")}
                className="flex items-center gap-2 dark:focus:bg-neutral-800  dark:focus:text-white">
                <Square3Stack3DIcon className="w-4 h-4 dark:text-white" />

                <Typography variant="small" className="font-bold">
                  My predictions
                </Typography>
              </MenuItem>

              <MenuItem
                onClick={() => handleNavigation("settings")}
                className="flex items-center gap-2 dark:focus:bg-neutral-800  dark:focus:text-white">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.48999 1.17C9.10999 -0.39 6.88999 -0.39 6.50999 1.17C6.45326 1.40442 6.34198 1.62213 6.18522 1.80541C6.02845 1.9887 5.83063 2.13238 5.60784 2.22477C5.38505 2.31716 5.1436 2.35564 4.90313 2.33709C4.66266 2.31854 4.42997 2.24347 4.22399 2.118C2.85199 1.282 1.28199 2.852 2.11799 4.224C2.65799 5.11 2.17899 6.266 1.17099 6.511C-0.390006 6.89 -0.390006 9.111 1.17099 9.489C1.40547 9.54581 1.62322 9.65719 1.80651 9.81407C1.98979 9.97096 2.13343 10.1689 2.22573 10.3918C2.31803 10.6147 2.35639 10.8563 2.33766 11.0968C2.31894 11.3373 2.24367 11.5701 2.11799 11.776C1.28199 13.148 2.85199 14.718 4.22399 13.882C4.42993 13.7563 4.66265 13.6811 4.90318 13.6623C5.14371 13.6436 5.38527 13.682 5.60817 13.7743C5.83108 13.8666 6.02904 14.0102 6.18592 14.1935C6.34281 14.3768 6.45419 14.5945 6.51099 14.829C6.88999 16.39 9.11099 16.39 9.48899 14.829C9.54599 14.5946 9.65748 14.377 9.8144 14.1939C9.97132 14.0107 10.1692 13.8672 10.3921 13.7749C10.6149 13.6826 10.8564 13.6442 11.0969 13.6628C11.3373 13.6815 11.57 13.7565 11.776 13.882C13.148 14.718 14.718 13.148 13.882 11.776C13.7565 11.57 13.6815 11.3373 13.6628 11.0969C13.6442 10.8564 13.6826 10.6149 13.7749 10.3921C13.8672 10.1692 14.0107 9.97133 14.1939 9.81441C14.377 9.65749 14.5946 9.546 14.829 9.489C16.39 9.11 16.39 6.889 14.829 6.511C14.5945 6.45419 14.3768 6.34281 14.1935 6.18593C14.0102 6.02904 13.8666 5.83109 13.7743 5.60818C13.682 5.38527 13.6436 5.14372 13.6623 4.90318C13.681 4.66265 13.7563 4.42994 13.882 4.224C14.718 2.852 13.148 1.282 11.776 2.118C11.5701 2.24368 11.3373 2.31895 11.0968 2.33767C10.8563 2.35639 10.6147 2.31804 10.3918 2.22574C10.1689 2.13344 9.97095 1.9898 9.81407 1.80651C9.65718 1.62323 9.5458 1.40548 9.48899 1.171L9.48999 1.17ZM7.99999 11C8.79564 11 9.55871 10.6839 10.1213 10.1213C10.6839 9.55871 11 8.79565 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79564 5 7.99999 5C7.20434 5 6.44128 5.31607 5.87867 5.87868C5.31606 6.44129 4.99999 7.20435 4.99999 8C4.99999 8.79565 5.31606 9.55871 5.87867 10.1213C6.44128 10.6839 7.20434 11 7.99999 11Z"
                    fill="#f4f4f4"
                  />
                </svg>

                <Typography variant="small" className="font-bold">
                  Settings
                </Typography>
              </MenuItem>
              {authUser && authUser.isAdmin && (
                <>
                  <hr className="my-2 border-blue-gray-50" />
                  <p className="font-light text-gray-500 ml-2">
                    Admin
                  </p>
                  <MenuItem
                    onClick={() => handleNavigation("feedbacks")}
                    className="flex items-center gap-2 dark:focus:bg-neutral-800  dark:focus:text-white">

                    <InboxIcon className="w-4 h-4 dark:text-white" />

                    <Typography variant="small" className="font-bold">
                      Feedbacks
                    </Typography>
                  </MenuItem>
                </>
              )}

              <hr className="my-2 border-blue-gray-50" />
              <MenuItem
                onClick={signOut}
                className="flex items-center gap-2 dark:focus:bg-neutral-800  dark:focus:text-white">
                <svg
                  width="16"
                  height="14"
                  viewBox="0 0 16 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14C1.26522 14 1.51957 13.8946 1.70711 13.7071C1.89464 13.5196 2 13.2652 2 13V1C2 0.734784 1.89464 0.48043 1.70711 0.292893C1.51957 0.105357 1.26522 0 1 0ZM11.293 9.293C11.1108 9.4816 11.01 9.7342 11.0123 9.9964C11.0146 10.2586 11.1198 10.5094 11.3052 10.6948C11.4906 10.8802 11.7414 10.9854 12.0036 10.9877C12.2658 10.99 12.5184 10.8892 12.707 10.707L15.707 7.707C15.8945 7.51947 15.9998 7.26516 15.9998 7C15.9998 6.73484 15.8945 6.48053 15.707 6.293L12.707 3.293C12.6148 3.19749 12.5044 3.12131 12.3824 3.0689C12.2604 3.01649 12.1292 2.9889 11.9964 2.98775C11.8636 2.9866 11.7319 3.0119 11.609 3.06218C11.4861 3.11246 11.3745 3.18671 11.2806 3.2806C11.1867 3.3745 11.1125 3.48615 11.0622 3.60905C11.0119 3.73194 10.9866 3.86362 10.9877 3.9964C10.9889 4.12918 11.0165 4.2604 11.0689 4.3824C11.1213 4.50441 11.1975 4.61475 11.293 4.707L12.586 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8H12.586L11.293 9.293Z"
                    fill="#90A4AE"
                  />
                </svg>
                <Typography variant="small" className="font-bold">
                  Sign Out
                </Typography>
              </MenuItem>
            </MenuList>
          </Menu>
        </div>

      </div>
    </>
  );
}
